import { useEffect, useState } from "react";
import PinnedImage from "../../components/pinned-image";
import classes from './score-result-styles.module.css'
const ScoreResult = (props) => {
    const { winner } = props
    const [messageEng, setMessageEng] = useState('')
    const [messageAr, setMessageAr] = useState('')

    useEffect(() => {
        if (winner === 'chandler') {
            setMessageEng(`
            So you’re the funniest of them all! You surely spend your spare time watching tv. but imagine if you know your compliance rules the same way you know “Friends” 
could you possibly get any cooler ??!
And always Remember, Knowledge is power, with great powers come great responsibility, Act responsibly !`)
        }
        else if (winner === 'ross') {
            setMessageEng(`
            You’re more comfortable with a book than a TV remote! You are genuine, intelligent and Knowledgeable. We can always count on you to do the right thing!
And always Remember, Knowledge is power, with great powers come great responsibility, Act responsibly ! `)
        }
        else if (winner === 'monica') {
            setMessageEng(`
            Wow you didn’t miss a single one !
You know the rules, but you know how to have fun as well...
you are a mix of both worlds! 
And always remember, Knowledge is power, with great powers come great responsibility, Act responsibly !
            `)
        }
        else if (winner === 'joey') {
            setMessageEng('What a classic Joey you are!')
        }
        else if (winner === 'rachel') {
            setMessageEng(`
            One of your best qualities is that you always try! Great job your almost there !
And always Remember, Knowledge is power, with great powers come great responsibility, Act responsibly ! `)
            // setMessageAr('!عاش ولا اجابة غلط')
        }
    }, [winner])
    return (
        <div className={classes.container}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <h1 className={classes.scoreBoard}>SCOREBOARD</h1>

                <PinnedImage winner={winner} />
            </div>
            <div className={classes.innerContainer}>
                <h1 className={classes.messageEn}>{messageEng}</h1>
                <h1 className={classes.messageAr}>{messageAr}</h1>
                <div className={classes.nextContainer}>
                    <div className={classes.nextButton} onClick={() => props.displayFinishMessage()} />
                </div>
            </div>


        </div>
    )
}
export default ScoreResult;